(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cro-sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cro-sticky-cart')) {
    customElements.define('cro-sticky-cart', class CroStickyCart extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.mediaQuery = window.matchMedia('(max-width: 749px)');
        this.action = this.querySelector('[data-cro-action]');
        this.price = this.querySelector('[data-cro-price]');
        this.productLine = this.querySelector('[data-cro-product-line]');
        this.productName = this.querySelector('[data-cro-product]');
        this.variantLine = this.querySelector('[data-cro-variant-line]');
        this.variantInfo = this.querySelector('[data-cro-variant]');
        this.batteryInfo = this.querySelector('[data-cro-battery]');
        this.secondary = this.querySelector('[data-cro-secondary]');
        this.comparePrice = this.querySelector('[data-cro-compare]');
        this.saving = this.querySelector('[data-cro-saving]');
        this.variants = this.readVariants();
        this.pendingVariantId = Number(this.dataset.initialVariantId);
        this.syncFrame = null;
        this.visibilityFrame = null;

        this.handleAction = this.handleAction.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleVariantChange = this.handleVariantChange.bind(this);

        this.action?.addEventListener('click', this.handleAction);
        window.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener('resize', this.handleResize);
        this.mediaQuery.addEventListener('change', this.handleResize);
        document.addEventListener('change', this.handleChange, true);
        document.addEventListener('variant:change', this.handleVariantChange);

        this.resolveContext();
      }

      disconnectedCallback() {
        this.initialized = false;
        this.action?.removeEventListener('click', this.handleAction);
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
        this.mediaQuery?.removeEventListener('change', this.handleResize);
        document.removeEventListener('change', this.handleChange, true);
        document.removeEventListener('variant:change', this.handleVariantChange);
        this.contextObserver?.disconnect();
        this.buttonObserver?.disconnect();
        if (this.syncFrame) cancelAnimationFrame(this.syncFrame);
        if (this.visibilityFrame) cancelAnimationFrame(this.visibilityFrame);
      }

      readVariants() {
        try {
          return JSON.parse(this.querySelector('[data-cro-variants]')?.textContent || '[]');
        } catch (error) {
          return [];
        }
      }

      resolveContext() {
        const ownSection = this.closest('.shopify-section');
        let candidateSection = ownSection?.previousElementSibling;
        let form = null;

        while (candidateSection && !form) {
          form = candidateSection.querySelector('form[action*="/cart/add"]');
          candidateSection = candidateSection.previousElementSibling;
        }

        if (!form) {
          form = Array.from(document.querySelectorAll('main form[action*="/cart/add"]'))
            .find((candidate) => !this.contains(candidate));
        }

        const originalButton = form?.querySelector('button[type="submit"], input[type="submit"]');

        if (!form || !originalButton) {
          this.form = null;
          this.originalButton = null;
          this.productSection = null;
          this.setVisible(false);
          return;
        }

        this.form = form;
        this.originalButton = originalButton;
        this.productSection = form.closest('.shopify-section') || form.parentElement;
        this.observeContext();
        this.scheduleSync();
        this.scheduleVisibility();
      }

      observeContext() {
        this.contextObserver?.disconnect();
        this.buttonObserver?.disconnect();

        this.contextObserver = new MutationObserver(() => {
          if (!this.originalButton?.isConnected) {
            this.resolveContext();
            return;
          }

          this.scheduleSync();
          this.scheduleVisibility();
        });

        this.contextObserver.observe(this.productSection, {
          childList: true,
          subtree: true
        });

        this.buttonObserver = new MutationObserver(() => this.scheduleSync());
        this.buttonObserver.observe(this.originalButton, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true,
          attributeFilter: ['disabled', 'aria-disabled', 'value']
        });
      }

      handleAction() {
        this.syncState();
        if (this.action?.disabled || !this.originalButton?.isConnected) return;
        this.originalButton.click();
      }

      handleScroll() {
        this.scheduleVisibility();
      }

      handleResize() {
        this.scheduleVisibility();
      }

      handleChange(event) {
        if (!this.productSection?.contains(event.target)) return;
        this.scheduleSync();
      }

      handleVariantChange(event) {
        const variantId = Number(event.detail?.variant?.id);
        if (variantId) this.pendingVariantId = variantId;
        this.scheduleSync();
      }

      scheduleSync() {
        if (this.syncFrame) cancelAnimationFrame(this.syncFrame);
        this.syncFrame = requestAnimationFrame(() => {
          this.syncFrame = null;
          this.syncState();
        });
      }

      scheduleVisibility() {
        if (this.visibilityFrame) return;
        this.visibilityFrame = requestAnimationFrame(() => {
          this.visibilityFrame = null;
          this.updateVisibility();
        });
      }

      syncState() {
        if (!this.originalButton?.isConnected || !this.form?.isConnected) {
          this.resolveContext();
          return;
        }

        const formVariantId = Number(this.form.querySelector('[name="id"]')?.value);
        const variantId = formVariantId || this.pendingVariantId;
        const variant = this.variants.find((item) => Number(item.id) === variantId);

        if (variant) {
          this.pendingVariantId = Number(variant.id);
          this.updatePrice(variant);
        }

        const originalDisabled = this.originalButton.disabled || this.originalButton.getAttribute('aria-disabled') === 'true';
        const available = variant ? variant.available && !originalDisabled : !originalDisabled;
        const originalLabel = this.readButtonLabel(this.originalButton);

        if (this.action) {
          this.action.disabled = !available;
          this.action.textContent = originalLabel || (available ? this.dataset.addLabel : this.dataset.unavailableLabel);
        }

        this.updateVisibility();
      }

      updatePrice(variant) {
        const compareValue = Number(variant.compare_at_price || 0);
        const priceValue = Number(variant.price || 0);
        const hasComparePrice = compareValue > priceValue;
        const showComparePrice = this.dataset.showComparePrice === 'true';
        const showSaving = this.dataset.showSaving === 'true';
        const productTitle = String(this.dataset.productTitle || '').trim();
        const variantTitle = String(variant.title || '').trim();
        const selectedOptions = variantTitle && variantTitle !== 'Default Title' ? variantTitle : '';
        const batteryChoice = this.readBatteryChoice();
        const batteryAlreadyIncluded = batteryChoice && selectedOptions.toLowerCase().includes(batteryChoice.toLowerCase());
        const showBatteryBadge = /100\s*%/.test(batteryChoice);
        const showVariantInfo = this.dataset.showVariantInfo === 'true';

        if (this.price) this.price.textContent = this.formatMoney(priceValue);
        if (this.productName) {
          this.productName.textContent = productTitle;
          this.productName.hidden = !showVariantInfo || !productTitle;
        }
        if (this.productLine) {
          this.productLine.hidden = !showVariantInfo || (!productTitle && !batteryChoice);
        }
        if (this.variantInfo) {
          this.variantInfo.textContent = selectedOptions;
          this.variantInfo.hidden = !showVariantInfo || !selectedOptions;
        }
        if (this.batteryInfo) {
          this.batteryInfo.textContent = batteryChoice;
          this.batteryInfo.hidden = !showVariantInfo || !showBatteryBadge || batteryAlreadyIncluded;
        }
        if (this.variantLine) {
          this.variantLine.hidden = !showVariantInfo || !selectedOptions;
        }
        if (this.comparePrice) {
          this.comparePrice.textContent = this.formatMoney(compareValue);
          this.comparePrice.hidden = !hasComparePrice || !showComparePrice;
        }
        if (this.saving) {
          this.saving.textContent = `${this.dataset.savingLabel} ${this.formatMoney(compareValue - priceValue)}`;
          this.saving.hidden = !hasComparePrice || !showSaving;
        }
        if (this.secondary) this.secondary.hidden = !hasComparePrice || (!showComparePrice && !showSaving);
      }

      readBatteryChoice() {
        const selectedRadio = this.productSection?.querySelector('input[type="radio"][name*="battery-choice"]:checked');
        if (selectedRadio) return String(selectedRadio.value || '').trim();

        const selectedOption = this.productSection?.querySelector('select[name*="battery-choice"] option:checked');
        return String(selectedOption?.value || selectedOption?.textContent || '').trim();
      }

      updateVisibility() {
        if (!this.originalButton?.isConnected || !this.mediaQuery.matches) {
          this.setVisible(false);
          return;
        }

        const rect = this.originalButton.getBoundingClientRect();
        this.setVisible(rect.bottom <= this.getHeaderBoundary());
      }

      getHeaderBoundary() {
        let boundary = 0;

        document.querySelectorAll('header.shopify-section--header, header[role="banner"], body > header')
          .forEach((header) => {
            const style = getComputedStyle(header);
            if (style.position !== 'sticky' && style.position !== 'fixed') return;

            const rect = header.getBoundingClientRect();
            const isCoveringViewportTop = rect.top <= 1 && rect.bottom > 0;
            if (!isCoveringViewportTop) return;

            boundary = Math.max(boundary, rect.bottom);
          });

        return boundary;
      }

      setVisible(visible) {
        this.classList.toggle('is-visible', visible);
        this.setAttribute('aria-hidden', String(!visible));

        if (visible) {
          this.removeAttribute('inert');
        } else {
          this.setAttribute('inert', '');
        }
      }

      readButtonLabel(button) {
        if (!button) return '';
        if (button.tagName === 'INPUT') return button.value.trim();
        return button.innerText.trim();
      }

      formatMoney(cents) {
        const fallbackToken = `${String.fromCharCode(123, 123)}amount${String.fromCharCode(125, 125)}`;
        const format = this.dataset.moneyFormat || fallbackToken;
        const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
        const placeholder = match?.[1] || 'amount';
        let precision = 2;
        let thousands = ',';
        let decimal = '.';

        if (placeholder.includes('no_decimals')) precision = 0;
        if (placeholder.includes('comma_separator')) {
          thousands = '.';
          decimal = ',';
        }
        if (placeholder.includes('space_separator')) {
          thousands = ' ';
          decimal = ',';
        }
        if (placeholder.includes('apostrophe_separator')) thousands = "'";

        const fixed = (Number(cents || 0) / 100).toFixed(precision);
        const parts = fixed.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        const amount = precision > 0 ? `${parts[0]}${decimal}${parts[1]}` : parts[0];

        return match ? format.replace(match[0], amount) : `${format}${amount}`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
